// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kadabra: PokeData = {
  "id": 64,
  "name": "kadabra",
  "height": 13,
  "weight": 565,
  "base_experience": 140,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "disable",
    "psybeam",
    "confusion",
    "psychic",
    "hypnosis",
    "teleport",
    "night-shade",
    "recover",
    "reflect",
    "kinesis",
    "flash",
    "substitute",
    "future-sight",
    "trick",
    "role-play",
    "calm-mind",
    "miracle-eye",
    "psycho-cut",
    "zen-headbutt",
    "psyshock",
    "telekinesis",
    "ally-switch"
  ],
  "moves": [
    "psychic",
    "night-shade",
    "reflect",
    "kinesis",
    "future-sight",
    "calm-mind",
    "zen-headbutt",
    "psy-ball",
    "psychic-fangs",
    "healing-wish",
    "psychic-terrain",
    "psy-pulse",
    "prismatic-cage"
  ],
  "evolution_chain": {
    "id": 27,
    "item": null,
    "species": [
      {
        "name": "abra",
        "order": 69,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kadabra",
        "order": 70,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 63,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "alakazam",
        "order": 71,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 64,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 45,
    "speed": 105,
    "ability_power": 120
  },
  "stat_changes": [],
  "catch_rate": 100,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
